
export const trendClassCompareStatisticsMap = {
  path: '/trendClassCompareStatistics',
  component: () => import('@/views/trendClassCompareStatistics/index.vue'),
  meta: { },
  children: [
    {
      path: 'height',
      component: () =>
        import(
          '@/views/trendClassCompareStatistics/detail/height/index.vue'
        ),
      meta: { title: '身高分布' }
    },
    {
      path: 'bmi',
      meta: { title: 'BMI分布' },
      component: () =>
        import(
          '@/views/trendClassCompareStatistics/detail/bmi/index.vue'
        )
    },
    {
      path: 'avg',
      meta: { title: '' },
      component: () => import('@/views/trendClassCompareStatistics/detail/avg/index.vue'),
      children: [
        {
          path: 'index',
          meta: { title: '综合能力均分' },
          component: () => import('@/views/trendClassCompareStatistics/detail/avg/main.vue')
        }
      ]
    },
    {
      path: 'distribution',
      component: () => import('@/views/trendClassCompareStatistics/detail/distribution/index.vue'),
      meta: { title: '综合能力分布' }
    }
  ]
}
